import { isFunction } from 'lodash/fp';

let getOnboardingStep;
if (process.env.BROWSER) {
    getOnboardingStep = require('./config/getOnboardingStep').default;
} else {
    getOnboardingStep = require('./config/getOnboardingStepElectron').default;
}

const hasFunctionSelector = (step) => isFunction(step.getIn(['tip', 'selector']));

export const selectStep = (stepId, action, state) => {
    let step = getOnboardingStep(stepId);

    if (step && hasFunctionSelector(step)) {
        step = step.setIn(['tip', 'selector'], step.getIn(['tip', 'selector'])(action, state));
    }

    return step;
};

export const getNextStepBasedOnAction = (next, action, state) => {
    if (!next) return;

    const nextTo = next(action, state);

    return nextTo && selectStep(nextTo, action, state);
};
